import { storeApi, filterProductsBySearch, type Product } from '@landi/store-core';

let cachedProducts: Product[] | null = null;
let loadPromise: Promise<Product[]> | null = null;

/** Returns cached catalog when already loaded, otherwise null. */
export function getCachedProducts(): Product[] | null {
  return cachedProducts;
}

/** Starts loading the full product catalog (deduped across callers). */
export function prefetchProductCatalog(): Promise<Product[]> {
  return loadProductCatalog();
}

/** Loads the full catalog once per session; subsequent calls reuse memory cache. */
export async function loadProductCatalog(force = false): Promise<Product[]> {
  if (!force && cachedProducts) {
    return cachedProducts;
  }

  if (!force && loadPromise) {
    return loadPromise;
  }

  loadPromise = storeApi
    .getProducts()
    .then((products) => {
      cachedProducts = products;
      loadPromise = null;
      return products;
    })
    .catch((error: unknown) => {
      loadPromise = null;
      throw error;
    });

  return loadPromise;
}

/** Client-side search against the cached catalog (loads catalog on first use). */
export async function searchCachedProducts(query: string): Promise<Product[]> {
  const catalog = await loadProductCatalog();
  return filterProductsBySearch(catalog, query);
}

/** Clears session cache (useful for tests). */
export function clearProductCatalogCache(): void {
  cachedProducts = null;
  loadPromise = null;
}
